const now = Date.now();

export const mockToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NzAyMzc5OTYsInJvbGUiOlsiQURNSU4iXSwiZ3JvdXBzaWQiOlsxXSwiZ2l2ZW5fbmFtZSI6Ik1vY2sgVXNlciIsInVuaXF1ZV9uYW1lIjoibW9jay51c2VyIn0.mock";

export const mockAuthResponse = {
  token: mockToken,
  groups: ["Reports_Admins"],
  username: "mock.user",
  name: "Mock User",
  email: "mock.user@example.com",
};

export const mockPaths = {
  1: "/Executive/Overview",
  2: "/Finance/Forecast",
  3: "/PRE",
  4: "/HR/Documents",
};

const baseFilters = [
  {
    id: 1,
    name: "Year",
    stringToMatch: "YEAR",
    parameter: "YEAR",
    type: "normal",
    positionNumber: 1,
    filterValues: [
      { id: 101, label: "2025", value: "2025", order: 1, default: true },
      { id: 102, label: "2024", value: "2024", order: 2 },
    ],
  },
  {
    id: 2,
    name: "Month",
    stringToMatch: "MONTH",
    parameter: "MONTH",
    type: "normal",
    positionNumber: 2,
    filterValues: [
      { id: 201, label: "Jan", value: "JAN", order: 1, default: true },
      { id: 202, label: "Feb", value: "FEB", order: 2 },
    ],
  },
];

export const mockSidebarItems = [
  {
    name: "Executive",
    icon: "leaderboard",
    isCollection: false,
    childrens: [],
    layout: { id: 1, name: "Executive Dashboard" },
  },
  {
    name: "Finance",
    icon: "analytics",
    isCollection: false,
    childrens: [
      {
        name: "Forecast",
        icon: "insights",
        childrens: [],
        layout: { id: 2, name: "Financial Forecast" },
      },
    ],
  },
  {
    name: "PRE",
    icon: "event",
    isCollection: false,
    isInternal: true,
    internalLink: "PRE",
    childrens: [],
  },
  {
    name: "HR Documents",
    icon: "assignment",
    isCollection: false,
    childrens: [],
    layout: { id: 4, name: "HR Documents" },
  },
];

export const mockCollections = [
  {
    name: "My Collection",
    icon: "folder",
    isCollection: true,
    childrens: [
      {
        name: "Executive Dashboard",
        layout: { id: 1, name: "Executive Dashboard" },
        childrens: [],
      },
      {
        name: "Financial Forecast",
        layout: { id: 2, name: "Financial Forecast" },
        childrens: [],
      },
    ],
  },
];

export const mockLayoutsList = [
  { id: 1, name: "Executive Dashboard", description: "KPI overview", owner: "mock.user" },
  { id: 2, name: "Financial Forecast", description: "Finance view", owner: "mock.user" },
  { id: 4, name: "HR Documents", description: "Documents", owner: "mock.user" },
];

export const mockLayoutDetails = {
  1: {
    id: 1,
    name: "Executive Dashboard",
    description: "Executive KPIs",
    source: "https://example.com/exec?documentID=1",
    tabs: [
      {
        tabId: 10,
        tabValue: "Overview",
        sourceUrl: "https://example.com/exec/overview",
        filters: baseFilters,
        redirect: false,
      },
      {
        tabId: 11,
        tabValue: "Drilldown",
        sourceUrl: "https://example.com/exec/drilldown",
        filters: baseFilters,
        redirect: false,
        redirectSources: [{ name: "Open external", url: "https://example.com/exec/drilldown" }],
      },
    ],
    params: {},
    filters: baseFilters,
    requiredNormalAuth: false,
    sso: false,
    requireFormatNumber: false,
  },
  2: {
    id: 2,
    name: "Financial Forecast",
    description: "Finance summary",
    source: "https://example.com/finance?documentID=2",
    tabs: [
      {
        tabId: 20,
        tabValue: "Summary",
        sourceUrl: "https://example.com/finance/summary",
        filters: baseFilters,
        redirect: false,
      },
      {
        tabId: 21,
        tabValue: "Backlog",
        sourceUrl: "https://example.com/finance/backlog",
        filters: baseFilters,
        redirect: true,
      },
    ],
    params: {},
    filters: baseFilters,
    requiredNormalAuth: false,
    sso: false,
    requireFormatNumber: false,
  },
  4: {
    id: 4,
    name: "HR Documents",
    description: "HR paperwork",
    source: "https://example.com/hr/documents",
    tabs: [],
    params: {},
    filters: baseFilters,
    requiredNormalAuth: false,
    sso: false,
    requireFormatNumber: false,
  },
};

export const mockFavorites = [
  { id: 1001, layoutId: 1 },
  { id: 1002, layoutId: 2 },
];

export const mockFavoriteLayouts = [
  { id: 301, layoutId: 1, name: "Executive Dashboard" },
  { id: 302, layoutId: 2, name: "Financial Forecast" },
  { id: 303, layoutId: 4, name: "HR Documents" },
];

export const mockRecents = {
  data: [
    {
      date: new Date(now - 3600 * 1000).toISOString(),
      description: "Visited Executive Dashboard",
      resource: "/Layout/1",
    },
    {
      date: new Date(now - 7200 * 1000).toISOString(),
      description: "Opened Financial Forecast",
      resource: "/Layout/2",
    },
  ],
  totalCount: 2,
  page: 0,
};

export const mockUsers = [
  { id: 1, username: "mock.user", email: "mock.user@example.com", name: "Mock User" },
  { id: 2, username: "admin.user", email: "admin@example.com", name: "Admin User" },
];

export const mockUserMe = {
  user: {
    name: "Mock User",
    email: "mock.user@example.com",
    roles: ["ADMIN"],
    permissions: [],
    groups: ["Reports_Admins"],
    username: "mock.user",
  },
};

export const mockAuditLog = {
  data: [
    {
      id: 1,
      resource: "Layout",
      category: "SIDEBAR",
      action: "CLICK",
      date: new Date(now - 5000).toISOString(),
      user: "mock.user",
      description: "Clicked Executive Dashboard",
    },
  ],
  totalPages: 1,
  page: 0,
};
